import SpeakerMute from './SpeakerMute'

export default SpeakerMute
// eslint-disable-next-line import/export
export * from './SpeakerMute'
